<div class="cta-mega-card-container">
  @if (block.data.isLinkWrapped) {
    <a
      [href]="block.data.button.link"
      class="cta-mega-card--link-wrapper"
      [attr.aria-label]="block.data.button.ariaLabel || block.data.heading">
      <section
        class="cta-mega-card link-wrapped"
        [ngClass]="{
          'cta-mega-card--right': block.data.imagePosition === 'right',
          'cta-mega-card--left': block.data.imagePosition === 'left',
          'cta-mega-card--top': block.data.imagePosition === 'top',
          'cta-mega-card--bottom': block.data.imagePosition === 'bottom',

          'cta-mega-card--half': block.data.imageWidth === 'half',
          'cta-mega-card--third': block.data.imageWidth === 'third',
          'cta-mega-card--fourth': block.data.imageWidth === 'fourth',
          'cta-mega-card--fifth': block.data.imageWidth === 'fifth',

          'cta-mega-card--neutral': block.data.backgroundColor === 'neutral',
          'cta-mega-card--primary': block.data.backgroundColor === 'primary',
          'cta-mega-card--reverse': block.data.backgroundColor === 'reverse',
          'cta-mega-card--white': block.data.backgroundColor === 'white',
          'cta-mega-card--wired': block.data.backgroundColor === 'wired',
        }"
        aria-labelledby="cta-mega-card__panel-heading">
        @if (block.data.hasImage) {
          <div class="cta-mega-card__panel cta-mega-card__panel--img">
            <img class="cta-mega-card__panel-img" [src]="imageUrl" alt="TODO" />
          </div>
        }
        <div class="cta-mega-card__panel cta-mega-card__panel--content">
          <h3 id="cta-mega-card__panel-heading" class="cta-mega-card__panel-heading">
            <span [innerText]="block.data.heading | translate"></span>
            @if (block.data.button.hasIcon) {
              <span class="heading-icon">
                <ng-container [ngTemplateOutlet]="getIconTemplate(block.data.button.iconType)"></ng-container>
              </span>
            }
          </h3>
          <p class="cta-mega-card__panel-description" [innerHTML]="block.data.description | translate"></p>
        </div>
      </section>
    </a>
  } @else {
    <section
      class="cta-mega-card"
      [ngClass]="{
        'cta-mega-card--right': block.data.imagePosition === 'right',
        'cta-mega-card--left': block.data.imagePosition === 'left',
        'cta-mega-card--top': block.data.imagePosition === 'top',
        'cta-mega-card--bottom': block.data.imagePosition === 'bottom',

        'cta-mega-card--half': block.data.imageWidth === 'half',
        'cta-mega-card--third': block.data.imageWidth === 'third',
        'cta-mega-card--fourth': block.data.imageWidth === 'fourth',
        'cta-mega-card--fifth': block.data.imageWidth === 'fifth',

        'cta-mega-card--neutral': block.data.backgroundColor === 'neutral',
        'cta-mega-card--primary': block.data.backgroundColor === 'primary',
        'cta-mega-card--reverse': block.data.backgroundColor === 'reverse',
        'cta-mega-card--white': block.data.backgroundColor === 'white',
        'cta-mega-card--wired': block.data.backgroundColor === 'wired',
      }"
      aria-labelledby="cta-mega-card__panel-heading">
      @if (block.data.hasImage) {
        <div class="cta-mega-card__panel cta-mega-card__panel--img">
          <img class="cta-mega-card__panel-img" [src]="imageUrl" alt="TODO" />
        </div>
      }
      <div class="cta-mega-card__panel cta-mega-card__panel--content">
        <h3 id="cta-mega-card__panel-heading" class="cta-mega-card__panel-heading">
          <span [innerText]="block.data.heading | translate"></span>
          @if (block.data.button.hasIcon) {
            <span class="heading-icon">
              <ng-container [ngTemplateOutlet]="getIconTemplate(block.data.button.iconType)"></ng-container>
            </span>
          }
        </h3>
        <p class="cta-mega-card__panel-description" [innerHTML]="block.data.description | translate"></p>
        <core-coro-button [button]="block.data.button"></core-coro-button>
      </div>
    </section>
  }

  <ng-template #noLinkWrapper>
    <section
      class="cta-mega-card"
      [ngClass]="{
        'cta-mega-card--right': block.data.imagePosition === 'right',
        'cta-mega-card--left': block.data.imagePosition === 'left',
        'cta-mega-card--top': block.data.imagePosition === 'top',
        'cta-mega-card--bottom': block.data.imagePosition === 'bottom',

        'cta-mega-card--half': block.data.imageWidth === 'half',
        'cta-mega-card--third': block.data.imageWidth === 'third',
        'cta-mega-card--fourth': block.data.imageWidth === 'fourth',
        'cta-mega-card--fifth': block.data.imageWidth === 'fifth',

        'cta-mega-card--neutral': block.data.backgroundColor === 'neutral',
        'cta-mega-card--primary': block.data.backgroundColor === 'primary',
        'cta-mega-card--reverse': block.data.backgroundColor === 'reverse',
        'cta-mega-card--white': block.data.backgroundColor === 'white',
        'cta-mega-card--wired': block.data.backgroundColor === 'wired',
      }"
      aria-labelledby="cta-mega-card__panel-heading">
      @if (block.data.hasImage) {
        <div class="cta-mega-card__panel cta-mega-card__panel--img">
          <img class="cta-mega-card__panel-img" [src]="imageUrl" alt="TODO" />
        </div>
      }

      <div class="cta-mega-card__panel cta-mega-card__panel--content">
        <h3 id="cta-mega-card__panel-heading" class="cta-mega-card__panel-heading">
          <span [innerText]="block.data.heading | translate"></span>
          @if (block.data.button.hasIcon) {
            <span class="heading-icon">
              <ng-container [ngTemplateOutlet]="getIconTemplate(block.data.button.iconType)"></ng-container>
            </span>
          }
        </h3>

        <p class="cta-mega-card__panel-description" [innerHTML]="block.data.description | translate"></p>

        <core-coro-button [button]="block.data.button"></core-coro-button>
      </div>
    </section>
  </ng-template>
</div>

<!-- Icon Templates -->
<ng-template #arrow>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.33301 15.374C5.33301 14.6526 5.91778 14.0679 6.63913 14.0679L21.9416 14.0679L16.2172 8.94602C15.6796 8.46502 15.6337 7.6393 16.1147 7.10172C16.5957 6.56414 17.4214 6.51827 17.959 6.99926L26.2311 14.4006C26.5081 14.6484 26.6663 15.0024 26.6663 15.374C26.6663 15.7456 26.5081 16.0996 26.2311 16.3474L17.959 23.7487C17.4214 24.2297 16.5957 24.1839 16.1147 23.6463C15.6337 23.1087 15.6796 22.283 16.2172 21.802L21.9416 16.6801H6.63913C5.91778 16.6801 5.33301 16.0953 5.33301 15.374Z"
      fill="#1A1A1A" />
  </svg>
</ng-template>

<ng-template #extlink>
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M18.8 6.40016C18.8 5.81106 19.2776 5.3335 19.8667 5.3335H26.2667C26.8558 5.3335 27.3333 5.81106 27.3333 6.40016L27.3333 12.8002C27.3333 13.3893 26.8558 13.8668 26.2667 13.8668C25.6776 13.8668 25.2 13.3893 25.2 12.8002L25.2 8.97532L18.4876 15.6877C18.071 16.1043 17.3956 16.1043 16.9791 15.6877C16.5625 15.2712 16.5625 14.5958 16.9791 14.1792L23.6915 7.46683H19.8667C19.2776 7.46683 18.8 6.98927 18.8 6.40016ZM12.1426 7.46683L14.5333 7.46683C15.1224 7.46683 15.6 7.94439 15.6 8.5335C15.6 9.1226 15.1224 9.60016 14.5333 9.60016H12.1867C11.273 9.60016 10.6519 9.60099 10.1718 9.64022C9.70413 9.67843 9.46498 9.74768 9.29815 9.83268C8.89674 10.0372 8.57038 10.3636 8.36585 10.765C8.28085 10.9318 8.2116 11.171 8.17339 11.6386C8.13416 12.1187 8.13333 12.7398 8.13333 13.6535V20.4802C8.13333 21.3938 8.13416 22.015 8.17339 22.4951C8.2116 22.9627 8.28085 23.2019 8.36585 23.3687C8.57038 23.7701 8.89674 24.0964 9.29815 24.301C9.46498 24.386 9.70413 24.4552 10.1718 24.4934C10.6519 24.5327 11.273 24.5335 12.1867 24.5335H19.0133C19.927 24.5335 20.5481 24.5327 21.0282 24.4934C21.4959 24.4552 21.735 24.386 21.9018 24.301C22.3033 24.0964 22.6296 23.7701 22.8341 23.3687C22.9191 23.2019 22.9884 22.9627 23.0266 22.4951C23.0658 22.015 23.0667 21.3938 23.0667 20.4802V18.1335C23.0667 17.5444 23.5442 17.0668 24.1333 17.0668C24.7224 17.0668 25.2 17.5444 25.2 18.1335V20.5242C25.2 21.3829 25.2 22.0915 25.1529 22.6688C25.1039 23.2683 24.9987 23.8195 24.735 24.3372C24.3259 25.14 23.6732 25.7927 22.8704 26.2018C22.3527 26.4656 21.8015 26.5707 21.2019 26.6197C20.6247 26.6669 19.916 26.6668 19.0574 26.6668H12.1426C11.284 26.6668 10.5753 26.6669 9.99805 26.6197C9.39848 26.5707 8.84733 26.4656 8.32964 26.2018C7.52682 25.7927 6.8741 25.14 6.46504 24.3372C6.20126 23.8195 6.09613 23.2683 6.04714 22.6688C5.99998 22.0915 5.99999 21.3828 6 20.5242V13.6094C5.99999 12.7508 5.99998 12.0422 6.04714 11.4649C6.09613 10.8653 6.20126 10.3142 6.46504 9.79647C6.8741 8.99364 7.52682 8.34093 8.32964 7.93187C8.84733 7.66809 9.39848 7.56296 9.99805 7.51397C10.5753 7.4668 11.284 7.46682 12.1426 7.46683Z"
      fill="#1A1A1A" />
  </svg>
</ng-template>

<ng-template #pdf>
  <svg width="33" height="32" viewBox="0 0 33 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M15.9122 16.0043C15.7038 15.3377 15.708 14.0502 15.8288 14.0502C16.1788 14.0502 16.1455 15.5877 15.9122 16.0043ZM15.8413 17.971C15.5205 18.8127 15.1205 19.7752 14.658 20.5835C15.4205 20.2918 16.283 19.8668 17.2788 19.671C16.7497 19.271 16.2413 18.696 15.8413 17.971ZM11.9205 23.171C11.9205 23.2043 12.4705 22.946 13.3747 21.496C13.0955 21.7585 12.1622 22.5168 11.9205 23.171ZM18.6663 12.0002L24.333 12.0002V25.6668C24.333 26.221 23.8872 26.6668 23.333 26.6668L9.33301 26.6668C8.77884 26.6668 8.33301 26.221 8.33301 25.6668L8.33301 6.3335C8.33301 5.77933 8.77884 5.3335 9.33301 5.3335L17.6663 5.3335V11.0002C17.6663 11.5502 18.1163 12.0002 18.6663 12.0002ZM18.333 19.1585C17.4997 18.6502 16.9455 17.9502 16.5538 16.9168C16.7413 16.146 17.0372 14.9752 16.8122 14.2418C16.6163 13.0168 15.0455 13.1377 14.8205 13.9585C14.6122 14.721 14.8038 15.796 15.158 17.1668C14.6747 18.3168 13.9622 19.8585 13.458 20.7418C13.4538 20.7418 13.4538 20.746 13.4497 20.746C12.3205 21.3252 10.383 22.6002 11.1788 23.5793C11.4122 23.8668 11.8455 23.996 12.0747 23.996C12.8205 23.996 13.5622 23.246 14.6205 21.421C15.6955 21.0668 16.8747 20.6252 17.9122 20.4543C18.8163 20.946 19.8747 21.2668 20.5788 21.2668C21.7955 21.2668 21.8788 19.9335 21.3997 19.4585C20.8205 18.8918 19.1372 19.0543 18.333 19.1585ZM24.0413 9.7085L19.958 5.62516C19.7705 5.43766 19.5163 5.3335 19.2497 5.3335L18.9997 5.3335V10.6668L24.333 10.6668V10.4127C24.333 10.1502 24.2288 9.896 24.0413 9.7085ZM20.9538 20.346C21.1247 20.2335 20.8497 19.8502 19.1705 19.971C20.7163 20.6293 20.9538 20.346 20.9538 20.346Z"
      fill="black" />
  </svg>
</ng-template>
